import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useLimitedMode from '../../services/subscription/useLimitedMode'
import { IoMdAdd } from 'react-icons/io'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import CompanyBranchesCategories from '../../components/CompanyBranchesCategories/CompanyBranchesCategories'
import Button from '../../components/Buttons/Button'
import ContentSection from '../../components/UI/ContentSection'
import PageTitle from '../../components/UI/PageTitle'
import { useReportsContext } from '../../context/reports/reports'
import { branchesOf } from '../../helpers/branches'

const Branches = () => {
  const { t } = useTranslation()
  const { isLimited } = useLimitedMode()
  const { selectedOrg } = useReportsContext()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isExactPath = pathname === '/admin/branches'

  useEffect(() => {
    document.title = `${t('categories')} - ReportAll`
  }, [t])

  return (
    <ContentSection>
      {isExactPath ? (
        <>
          <div className='flex items-center gap-6 flex-wrap'>
            <PageTitle title={t('branches')} />
            <Button
              onClickHandler={() => navigate('create-branch')}
              text={t('newBranch')}
              type='button'
              disabled={isLimited}
              title={isLimited ? t('disabledUntilActivation') : undefined}
            >
              <IoMdAdd />
            </Button>
          </div>

          <CompanyBranchesCategories data={branchesOf(selectedOrg)} isLoading={false} type='branch' />
        </>
      ) : (
        <Outlet context={branchesOf(selectedOrg)} />
      )}
    </ContentSection>
  )
}

export default Branches
